import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { stripUnit } from 'polished';
import { typographyTheme } from '~typography';
import formTheme from '../../styles/formTheme';
var FormCheckboxLabel = styled.label.withConfig({
  displayName: "FormCheckboxLabel",
  componentId: "sc-19ukncb-0"
})(["cursor:pointer;display:inline-flex;font-family:", ";font-size:", ";margin-right:1rem;padding-left:", "rem;position:relative;z-index:1;min-height:", ";min-width:", ";vertical-align:middle;", ""], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, function (props) {
  return _get(props, "theme.form.checkbox.label.fontSize[" + props.sizeValue + "]", formTheme.form.checkbox.label.fontSize[props.sizeValue]);
}, function (props) {
  return stripUnit(_get(props, "theme.form.checkbox.size[" + props.sizeValue + "]", formTheme.form.checkbox.size[props.sizeValue])) * 1.5;
}, function (props) {
  return _get(props, "theme.form.checkbox.size[" + props.sizeValue + "]", formTheme.form.checkbox.size[props.sizeValue]);
}, function (props) {
  return _get(props, "theme.form.checkbox.size[" + props.sizeValue + "]", formTheme.form.checkbox.size[props.sizeValue]);
}, function (props) {
  return props.hideLabel && css(["margin-right:0;padding-left:0;"]);
});
export default FormCheckboxLabel;